import { useToggle } from "../../hooks/useToggle.js";
import { usePublishingContext } from "../../contexts/PublishingContext.js";
import { shortTimeFormatter } from "./utils/timeago-formatter.js";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useDateTimeDisplayContext } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import TimeAgo from "react-timeago";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import classnames from "classnames";
//#region src/components/DateTime/index.tsx
dayjs.extend(utc);
dayjs.extend(timezone);
function DateTime$1({ mode = "datetime", relative, shortFormat, timestamp, timezone, toggleRelativeOnClick = true, truncate = true }) {
	const publishingContext = usePublishingContext();
	const dateTimeDisplayContext = useDateTimeDisplayContext();
	const [relativeState, toggleRelativeState] = useToggle(!!relative && !publishingContext?.isPublishing);
	const allowToggleRelativeState = toggleRelativeOnClick && !publishingContext?.isPublishing;
	const dateStr = useMemo(() => {
		const dateFormat = dateTimeDisplayContext?.format?.date || shortFormat ? "MM-DD" : "YYYY-MM-DD";
		const timeFormat = dateTimeDisplayContext?.format?.time || dateTimeDisplayContext?.format?.is24hr ? "H:mm" : "h:mm A";
		if (mode === "date") return dayjs(timestamp).tz(timezone).format(dateFormat);
		else if (mode === "time") return dayjs(timestamp).tz(timezone).format(timeFormat);
		return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("span", { children: [dayjs(timestamp).tz(timezone).format(dateFormat), " "] }), /* @__PURE__ */ jsx("span", { children: dayjs(timestamp).tz(timezone).format(timeFormat) })] });
	}, [timestamp]);
	const handleClick = () => {
		if (allowToggleRelativeState) toggleRelativeState();
	};
	if (!timestamp) return null;
	return /* @__PURE__ */ jsx("span", {
		className: classnames({
			"hover:text-color-strong focus:text-color-strong active:text-color-subtle cursor-pointer transition-colors": allowToggleRelativeState,
			truncate
		}),
		onClick: handleClick,
		children: relativeState ? /* @__PURE__ */ jsx(TimeAgo, {
			date: timestamp,
			formatter: shortFormat ? shortTimeFormatter : void 0
		}) : /* @__PURE__ */ jsx("time", {
			dateTime: timestamp,
			title: timestamp,
			children: dateStr
		})
	});
}
DateTime$1.displayName = "DateTime";
//#endregion
export { DateTime$1 as DateTime };

//# sourceMappingURL=index.js.map